export default (items, limit) => {
	const chunks = [];
	for (let i = 0; i < items.length; i = i + limit) {
		const slice = items.slice(i, i + limit);
		chunks.push(slice);
	}
	return chunks;
};
